import React from 'react';

import { Wrapper } from './wrapper';

interface TooltipProps {
  children: React.ReactNode;
  tooltip?: string;
  $whiteSpace?: 'pre' | 'pre-wrap';
}

const Tooltip = ({ children, tooltip, $whiteSpace }: TooltipProps) => {
  if (!tooltip) {
    return <>{children}</>;
  }

  return (
    <Wrapper data-tooltip={tooltip} $whiteSpace={$whiteSpace}>
      {children}
    </Wrapper>
  );
};

export default Tooltip;
